import React from 'react'
import * as UI from 'ui'
import { Link } from '@morningtrain/react-navigation'

export default function ArrowLinkToOrder () {
  return (
    <Link route='app.inventory.order.edit' parameters={{ inventory_order: 'model:id', inventory_supplier: 'model:supplier_id' }}>
      <UI.SquareButton color='lightgray' className='p-2'>
        <UI.Icons.ArrowRight />
      </UI.SquareButton>
    </Link>
  )
}
